module.exports = __webpack_public_path__ + "static/media/Mood-Photo.19df606d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Home/photos/Mood-Photo.jpg
// module id = 239
// module chunks = 8